import { render } from "./NotaFiscalItemEstoques.vue?vue&type=template&id=739dbd94&scoped=true&ts=true"
import script from "./NotaFiscalItemEstoques.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalItemEstoques.vue?vue&type=script&lang=ts"

import "./NotaFiscalItemEstoques.vue?vue&type=style&index=0&id=739dbd94&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739dbd94"]])

export default __exports__